import Modal, { ModalFooter, ModalHeader, Prompt } from '@ingka/modal';
import Button from '@ingka/button';
import { useTranslation } from 'react-i18next';

export type StopLotteryModalProps = {
  visible: boolean;
  onClose: () => void;
  onStop: () => void;
};

export const StopLotteryModal: React.FC<StopLotteryModalProps> = ({ visible, onClose, onStop }) => {
  const { t } = useTranslation();
  const stopLotteryTitleId = t('general-stop-lottery');

  return (
    <Modal visible={visible} escapable={false} handleCloseBtn={onClose}>
      <Prompt
        aria-labelledby={stopLotteryTitleId}
        title={t('lottery-details-stop-modal-header')}
        titleId={stopLotteryTitleId}
        header={<ModalHeader ariaCloseTxt={`${t('general-close-prompt')}`} />}
        footer={
          <ModalFooter>
            <Button text={`${t('general-cancel')}`} type="secondary" onClick={onClose} />
            <Button text={`${t('general-stop-lottery')}`} type="primary" onClick={onStop} />
          </ModalFooter>
        }
      >
        <p>{t('lottery-details-stop-modal-text')}</p>
      </Prompt>
    </Modal>
  );
};
